module.exports = __webpack_public_path__ + "img/rho-17-about-julian.8b50dd90.jpeg";